"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var colors = _interopRequireWildcard(require("@cimpress/react-components/lib/colors"));

var _emotion = require("emotion");

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _uuid = require("uuid");

var _react = _interopRequireWildcard(require("react"));

var _Grid = _interopRequireDefault(require("react-virtualized/dist/commonjs/Grid"));

var _defaultCellRangeRenderer = _interopRequireDefault(require("react-virtualized/dist/commonjs/Grid/defaultCellRangeRenderer"));

var actions = _interopRequireWildcard(require("../editorActions"));

var cellStates = _interopRequireWildcard(require("../cellStates"));

var shapes = _interopRequireWildcard(require("../shapes"));

var utils = _interopRequireWildcard(require("../utils"));

var _SelectRegion = _interopRequireDefault(require("../SelectRegion"));

var _DocumentCellEditor = _interopRequireDefault(require("./DocumentCellEditor"));

var _DocumentCellViewer = _interopRequireDefault(require("./DocumentCellViewer"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  background-color: ", ";\n  outline: none;\n  overflow: scroll !important;\n  & .ReactVirtualized__Grid__innerScrollContainer {\n    background-color: ", ";\n    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var sheetStyle = (0, _emotion.css)(_templateObject(), colors.alloy, colors.white);
var willChangeDisable = {
  willChange: 'unset'
};

var Document =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(Document, _PureComponent);

  function Document() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Document);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Document)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      drag: false,
      gridKey: (0, _uuid.v4)()
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "gridRef", (0, _react.createRef)());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "rerenderKey", (0, _memoizeOne.default)(function () {
      return {};
    }));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getEditCellStyle", (0, _memoizeOne.default)(function (left, top, horizontalOffsetAdjustment, verticalOffsetAdjustment) {
      return {
        position: 'absolute',
        left: left.offset + horizontalOffsetAdjustment,
        width: left.size,
        top: top.offset + verticalOffsetAdjustment,
        height: top.size
      };
    }));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onCellEdit", function (value) {
      var dispatch = _this.props.dispatch;
      dispatch(actions.editActiveCell(value));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onCellEnter", function (columnIndex, rowIndex, initialValue) {
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          editing = _this$props.editing,
          selection = _this$props.selection;

      if (!selection || utils.isEditing(editing)) {
        return;
      }

      if (!utils.pointInSelection(selection, columnIndex, rowIndex)) {
        var left = columnIndex;
        var right = columnIndex + 1;
        var top = rowIndex;
        var bottom = rowIndex + 1;
        dispatch(actions.jumpSelection({
          left: left,
          right: right,
          top: top,
          bottom: bottom,
          activeX: left,
          activeY: top
        }));
      }

      dispatch(actions.editActiveCell(initialValue));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onCellLeave", function () {
      var dispatch = _this.props.dispatch;
      dispatch(actions.cancelActiveCell());
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onCellSelect", function (selection) {
      var dispatch = _this.props.dispatch;
      dispatch(actions.jumpSelection(selection));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onCellSubmit", function () {
      var dispatch = _this.props.dispatch;
      dispatch(actions.submitActiveCell());
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onDragStart", function (columnIndex, rowIndex) {
      var selection = {
        left: columnIndex,
        right: columnIndex + 1,
        top: rowIndex,
        bottom: rowIndex + 1,
        activeX: columnIndex,
        activeY: rowIndex
      };
      utils.emptyUserSelection();

      _this.onCellSelect(selection);

      document.addEventListener('mouseleave', _this.onDragEnd);
      document.addEventListener('mouseup', _this.onDragEnd);

      _this.setState({
        drag: true
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onDragMove", function (columnIndex, rowIndex) {
      var selection = _this.props.selection;
      var drag = _this.state.drag;

      if (!drag || !selection) {
        return;
      }

      var left = Math.min(selection.activeX, columnIndex);
      var right = Math.max(selection.activeX, columnIndex) + 1;
      var top = Math.min(selection.activeY, rowIndex);
      var bottom = Math.max(selection.activeY, rowIndex) + 1;
      var newSelection = (0, _objectSpread2.default)({}, selection, {
        left: left,
        right: right,
        top: top,
        bottom: bottom
      });

      _this.onCellSelect(newSelection);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onDragEnd", function () {
      document.removeEventListener('mouseleave', _this.onDragEnd);
      document.removeEventListener('mouseup', _this.onDragEnd);

      _this.setState({
        drag: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderCell", function (_ref) {
      var columnIndex = _ref.columnIndex,
          key = _ref.key,
          rowIndex = _ref.rowIndex,
          style = _ref.style;
      var _this$props2 = _this.props,
          columns = _this$props2.columns,
          editing = _this$props2.editing,
          rows = _this$props2.rows,
          selection = _this$props2.selection,
          readOnly = _this$props2.readOnly;
      var column = columns[columnIndex];
      var row = rows[rowIndex];
      var isEditing = utils.isEditing(editing);
      var mode = cellStates.getMode(columnIndex, rowIndex, selection, isEditing);

      if (mode === cellStates.editing && !readOnly) {
        return null;
      }

      return _react.default.createElement(_DocumentCellViewer.default, {
        key: key,
        column: column,
        columnIndex: columnIndex,
        mode: mode,
        row: row,
        rowIndex: rowIndex,
        style: style,
        onDragMove: _this.onDragMove,
        onDragStart: _this.onDragStart,
        onEdit: _this.onCellEnter
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderCellRange", function (props) {
      var _this$props3 = _this.props,
          editing = _this$props3.editing,
          selection = _this$props3.selection,
          readOnly = _this$props3.readOnly,
          columns = _this$props3.columns,
          rows = _this$props3.rows;
      var children = (0, _defaultCellRangeRenderer.default)(props);
      var columnSizeAndPositionManager = props.columnSizeAndPositionManager,
          horizontalOffsetAdjustment = props.horizontalOffsetAdjustment,
          rowSizeAndPositionManager = props.rowSizeAndPositionManager,
          verticalOffsetAdjustment = props.verticalOffsetAdjustment;

      if (selection && columns.length > 0 && rows.length > 0) {
        var left = columnSizeAndPositionManager.getSizeAndPositionOfCell(selection.left);
        var top = rowSizeAndPositionManager.getSizeAndPositionOfCell(selection.top);
        var right = columnSizeAndPositionManager.getSizeAndPositionOfCell(selection.right - 1);
        var bottom = rowSizeAndPositionManager.getSizeAndPositionOfCell(selection.bottom - 1);
        var width = right.offset + right.size - left.offset;
        var height = bottom.offset + bottom.size - top.offset;

        var selectRegion = _react.default.createElement(_SelectRegion.default, {
          key: "select-region",
          left: left.offset + horizontalOffsetAdjustment,
          top: top.offset + verticalOffsetAdjustment,
          width: width,
          height: height
        });

        children.push(selectRegion);
      }

      if (utils.isEditing(editing) && selection && !readOnly) {
        var activeX = selection.activeX,
            activeY = selection.activeY;

        var _left = columnSizeAndPositionManager.getSizeAndPositionOfCell(selection.activeX);

        var _top = rowSizeAndPositionManager.getSizeAndPositionOfCell(selection.activeY);

        var editCell = _react.default.createElement(_DocumentCellEditor.default, {
          key: "".concat(activeY, "-").concat(activeX, "-edit"),
          columnIndex: activeX,
          editing: editing,
          rowIndex: activeY,
          style: _this.getEditCellStyle(_left, _top, horizontalOffsetAdjustment, verticalOffsetAdjustment),
          onBlur: _this.onCellSubmit,
          onChange: _this.onCellEdit
        });

        children.push(editCell);
      }

      return children;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "recomputeGridSize", function (columnIndex, rowIndex) {
      _this.gridRef.current.recomputeGridSize({
        columnIndex: columnIndex,
        rowIndex: rowIndex
      });
    });
    return _this;
  }

  (0, _createClass2.default)(Document, [{
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          columns = _this$props4.columns,
          editing = _this$props4.editing,
          height = _this$props4.height,
          rowHeight = _this$props4.rowHeight,
          rows = _this$props4.rows,
          selection = _this$props4.selection,
          width = _this$props4.width,
          onScroll = _this$props4.onScroll,
          onGetColumnWidth = _this$props4.onGetColumnWidth,
          onGetFirstColumnWidth = _this$props4.onGetFirstColumnWidth;
      var heightWithoutTopRow = height - rowHeight;
      var leftRowWidth = onGetFirstColumnWidth();
      var widthWithoutLeftColumn = width - leftRowWidth;
      var scrollToColumn = selection ? selection.activeX : undefined;
      var scrollToRow = selection ? selection.activeY : undefined;
      return _react.default.createElement(_Grid.default, {
        key: this.state.gridKey,
        ref: this.gridRef,
        cellRenderer: this.renderCell,
        cellRangeRenderer: this.renderCellRange,
        className: sheetStyle,
        columnCount: columns.length,
        columnWidth: onGetColumnWidth,
        height: heightWithoutTopRow,
        overscanColumnCount: 0,
        overscanRowCount: 5,
        rerenderKey: this.rerenderKey(editing, rows, selection),
        rowCount: rows.length,
        rowHeight: rowHeight,
        scrollToColumn: scrollToColumn,
        scrollToRow: scrollToRow,
        style: willChangeDisable,
        tabIndex: null,
        width: widthWithoutLeftColumn,
        onScroll: onScroll
      });
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var newState = (0, _objectSpread2.default)({}, state);

      if (props.columns && props.columns.length === 0 && props.rows && props.rows.length === 0) {
        newState.gridKey = (0, _uuid.v4)();
      }

      return newState;
    }
  }]);
  return Document;
}(_react.PureComponent);

exports.default = Document;
(0, _defineProperty2.default)(Document, "propTypes", {
  columns: _propTypes.default.arrayOf(shapes.column).isRequired,
  dispatch: _propTypes.default.func.isRequired,
  editing: shapes.editing.isRequired,
  height: _propTypes.default.number.isRequired,
  rowHeight: _propTypes.default.number.isRequired,
  rows: _propTypes.default.arrayOf(shapes.row).isRequired,
  selection: shapes.selection,
  width: _propTypes.default.number.isRequired,
  onGetColumnWidth: _propTypes.default.func.isRequired,
  onGetFirstColumnWidth: _propTypes.default.func.isRequired,
  onScroll: _propTypes.default.func.isRequired,
  readOnly: _propTypes.default.bool.isRequired
});